/**
 * Address validation activation config.
 *
 * Real API calls only happen when REACT_APP_ADDRESS_VALIDATION_LIVE is the
 * string "true". Any other value (including undefined) leaves real providers
 * dormant.
 *
 * The strict equality check against the string "true" is intentional:
 *   - undefined → false
 *   - "1", "yes", "TRUE" → false (must be exact)
 *   - "true" → true
 *
 * This same expression is duplicated at module top in providerRegistry.js so
 * Terser can fold it at build time and tree-shake the mock provider out of
 * production bundles. Keep them in sync.
 */

export const isLive = () =>
  process.env.REACT_APP_ADDRESS_VALIDATION_LIVE === "true";

export const getSmartyKey = () => process.env.REACT_APP_SMARTY_KEY ?? "";

export const getGoogleKey = () =>
  process.env.REACT_APP_GOOGLE_ADDRESS_VALIDATION_KEY ?? "";

export const hasSmartyKey = () => Boolean(getSmartyKey());

export const hasGoogleKey = () => Boolean(getGoogleKey());
